<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}" class="dimmed_black" style="top:0;display:block;"></div>

    <div
      :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big"
      id="pop_cancelAro"
      style="display:block;"
    >
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">정기구매 주문 명칭 변경</span>
          <button class="rew19_basketList_btn" @click="onCancel">
            <span>닫기</span>
          </button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <div class="rew19_select_table">
          <ul class="rew19_transition_table">
            <li>
              <span class="with_type1">주문번호</span>
              <div class="txt_type">{{viewData.aro_no}}</div>
            </li>
            <li>
              <em class="with_type1">주문명칭</em>
              <div class="rew19_form_full">
                <input
                  name
                  title="주문명칭"
                  type="text"
                  class="autoFocus rew19_inputTxt_t1"
                  placeholder="홍길동 배송 바구니"
                  v-model="viewData.aro_tag"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
        <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
        <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>
  </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "AroNameChangeDialog",
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex: 2000,

      viewData: {
      }
    };
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show &&
        this.$nextTick(() => {
          let _this = this;
          _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

          this.$el.focus();
        });
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  mounted() {
    let _this = this;
  },
  methods: {
    onClose(response) {
      let _this = this;

      let resData = _this.viewData;
      _this.$emit('close', response, response ? resData: null);      
    },
    onCancel() {
      this.onClose(false);
    },
    onOk() {
      let _this = this;

      if(!_this.validateAroTag()){
        return;
      }

      let check = false;
      _this.$showLoading();      
      _this.apiAroTagValidation(_this.viewData.aro_tag).then(res=>{
        if (res.status === 200 && res.data.status === "0000") {
          check = true;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
        if(!check){
          return;
        }

        this.onClose(true);
      });
      
      
    },

    /**
     * API Request
     */
    apiAroTagValidation(aroTag){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/tag_validation`, {
        params: {
          aroTag: aroTag
        }
      });
    },

    /**
     * Local
     */
    initData: function(data) {
      let _this = this;

      _this.viewData = {
        ..._this.viewData,
        ...data
      };
    },

    validateAroTag(){
      let _this = this;
      let aroTag = _this.viewData.aro_tag;

      if(!aroTag){
        _this.$dialogs.alert("주문명칭을 입력해주세요.");
        return false;
      }

      let regExAroTag = /^[0-9A-Za-z가-힣ㄱ-ㅎ-ㅏ-ㅣ\-./,\s]*$/g;
      if(!regExAroTag.test(aroTag)){
        _this.$dialogs.alert("주문명칭은 특수문자를 사용할 수 없습니다.");
        return false;
      }

      if(aroTag.length < 2 || aroTag.length > 20){
        _this.$dialogs.alert("주문명칭은 2글자 이상 20자 이내로 사용 가능합니다.");
        return false;
      }

      return true;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/popup/aroNameChangeDialog.vue